import { Component, OnInit } from '@angular/core';
import { MarketplaceService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-events-page-v1',
  templateUrl: './events-page-v1.component.html',
  styleUrl: './events-page-v1.component.scss',
})
export class EventsPageV1Component implements OnInit {
  constructor(private marketplaceService: MarketplaceService) {}

  ngOnInit() {
    firstValueFrom(this.marketplaceService.fetchMarketplaceItems());
  }
}
